import { onboardingConstants } from "./onboardingConstants";

const onboardingActions = {};

onboardingActions.updateOnboardingData = (payload = {}) => ({
  type: onboardingConstants.UPDATE_ONBOARDING_DATA,
  payload,
});

onboardingActions.getOnboardingData = () => ({
  type: onboardingConstants.ONBOARDING_DATA_SAGA,
});

onboardingActions.getPortfolioData = () => ({
  type: onboardingConstants.PORTFOLIO_DATA_SAGA,
});

onboardingActions.getPricingData = () => ({
  type: onboardingConstants.PRICING_DATA_SAGA,
});

onboardingActions.getPricingDataResponse = (payload = {}) => ({
  type: onboardingConstants.PRICING_DATA_RESPONSE,
  payload,
});

export { onboardingActions };
